// extracted by mini-css-extract-plugin
module.exports = {"modal":"blacklisted-modal_modal__2PiVC","container":"blacklisted-modal_container__1BagU","title":"blacklisted-modal_title__3cosX","text":"blacklisted-modal_text__3a2C5"};